<script setup>
const props = defineProps({
    videoEmbedCode: {
        type: String,
        default: '',
    },
    anchorId: {
        type: String,
    },
});

const videoUrl = computed(() => {
    if (!props.videoEmbedCode) return '';
    const match = props.videoEmbedCode.match(/src=["']([^"']+)["']/);
    if (!match?.[1]) return '';
    const url = match[1];
    if (url.includes('youtube.com')) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}rel=0`;
    }
    return url;
});
</script>

<template>
    <section class="block-video-embed bg-[var(--pink)] px-[var(--box-padding-lr-m)] md:px-[var(--box-padding-lr)] py-[40px] md:py-[60px]"
        :id="anchorId || undefined" tabindex="-1">
        <div class="w-full mx-auto aspect-video rounded-[var(--radius)] overflow-hidden bg-[var(--magenta)]">
            <iframe v-if="videoUrl"
                class="w-full h-full display-block"
                loading="lazy"
                :src="videoUrl"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            />
        </div>
    </section>
</template>
